export default "__VITE_ASSET__CwPYqiBn__"